import moment from 'moment-timezone';

const backendMoment = (...args) => moment(...args).tz(process.env.REACT_APP_BACKEND_TZ)

export default string => backendMoment(string).format('DD/MM/YYYY HH:mm');

export const getDateAndTime = str => ({
  date: backendMoment(str).format('YYYY-MM-DD'),
  time: backendMoment(str).format('HH:mm'),
});
